<template>
  <div
    class=" 
        flex
        w-full
        bg-img
        vx-row
        justify-center 
      "
  >
    <div
      class="
          vx-col
        "
    >
      <vx-card class="vx-card-fsm justify-center items-center">
        <div slot="no-body" class="">
          <div class="p-8 vs-con-loading__container" id="loginSubmitButton">
            <div class="vx-card__title mb-8">
              <div class="flex">
                <h4 class="mb-4 w-full">
                  {{ $t("ForgotPageTitle") }}
                </h4>
              </div> 
            </div>
 
            <div>
              <ValidationObserver
                tag="form"
                ref="newPasswordForm"
                v-bind:key="'newPasswordFormEl'"
                v-on:submit.prevent
                v-slot="{ invalid }"
              >
              <ValidationProvider
                :name="$t('Login.OldPassword')"
                rules="required"
                v-slot="{ errors }"
              >
                <vs-input
                  type="password"
                  icon="icon icon-lock"
                  v-on:keyup.enter="newPassword"
                  icon-pack="feather"
                  :label-placeholder="$t('Login.OldPassword')"
                  v-model="formNewData.OldPassword"
                  class="w-full mt-6 no-icon-border"
                  ref="oldPasswordInput"
                  v-bind:key="'oldPasswordInput'"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
              
                <ValidationProvider
                  :name="$t('Login.NewPassword')"
                  rules="required|uppercase|anynumber|min:8|strongpassword|no_tr"
                  v-slot="{ errors }"
                >
                  <vs-input
                    type="password"
                    icon="icon icon-lock"
                    v-on:keyup.enter="newPassword"
                    icon-pack="feather"
                    :label-placeholder="$t('Login.NewPassword')"
                    v-model="formNewData.Password"
                    class="w-full mt-6 no-icon-border"
                    ref="passwordInput"
                    v-bind:key="'passwordInput'"
                  />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                  :name="$t('Login.NewPasswordRe')"
                  :rules="'required|confirmed:' + $t('Login.NewPassword')"
                  v-slot="{ errors }"
                >
                  <vs-input
                    type="password"
                    icon="icon icon-lock"
                    v-on:keyup.enter="newPassword"
                    icon-pack="feather"
                    :label-placeholder="$t('Login.NewPasswordRe')"
                    v-model="formNewData.PasswordRe"
                    class="w-full mt-6 no-icon-border"
                    ref="passwordInputRe"
                    v-bind:key="'passwordInputRe'"
                  />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
                <vs-button
                  class="w-100 my-2 mt-6 vs-con-loading__container"
                  :disabled="invalid"
                  @click="newPassword()"
                  >{{ $t("Login.NewPasswordButton") }}</vs-button
                >
              </ValidationObserver>
            </div>
          </div>
        </div>
      </vx-card> 
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Vue from "vue";
import AuthApi from "@/api/auth";
import CountDown from "@/components/countdown";

var checkSmsCounter = null;

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    CountDown,
  },
  data() {
    return {
      copyrightClass: "",
      localProfile: {},
      autoLogin: false,
      showUsernameForm: true,
      radios1: 1,
      KVKK: true,
      formDataLogin: {
        Username: "",
        Password: "",
        RememberMe: true,
        GoogleReCaptchaResponse: "",
        Referer: "",
        ReturnUrl: "",
      },
      formForgotData: {
        Email: "",
        GoogleReCaptchaResponse: "",
      },
      formSmsVerify: {
        UserId: null,
        SmsCode: null,
        GoogleReCaptchaResponse: "",
      },
      userAccounts: [],
      submitBusy: false,
      showWithoutPasswordPanel: false,
      showSmsConfirmPanel: false,
      smsExpiryDate: null,
      smsCounter: 0,
      smsUserId: null,
      smsPhone: null,
      smsMail: null,
      dateNow: null,
      showNewPasswordPanel: false,
      formNewData: {
        Token: null,
        OldPassword: "",
        Password: "",
        PasswordRe: "",
        GoogleReCaptchaResponse: "",
      },
    };
  },
  computed: {
    filteredFaq() {
      return [
        // {
        //   id: 1,
        //   question: this.$t("FaqPerson.Q1"),
        //   ans: this.$t("FaqPerson.A1"),
        // },
        {
          id: 1,
          question: this.$t("FaqPerson.Q2"),
          ans: this.$t("FaqPerson.A2"),
        },
      ];
    },
    showSmsTimer() {
      this.dateNow;
      return this.smsExpiryDate && new Date(this.smsExpiryDate) >= new Date();
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    isAuthenticated() {
      this.localProfile;
      return this.$auth.isAuthenticated();
    },
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale == "tr") return { flag: "tr", lang: "Türkçe" };
      else if (locale == "en") return { flag: "en", lang: "English" };
      else if (locale == "ar") return { flag: "ar", lang: "عربي" };
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },
  },
  beforeDestroy() {
    clearInterval(checkSmsCounter);
  },
  async created() {
    setTimeout(() => {
      this.copyrightClass = "show";
    }, 1000);
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      if (locale == "ar") this.$vs.rtl = true;
      else this.$vs.rtl = false;
    },
    async forgotSmsVerify() {
      const isValid = await this.$refs.forgotSmsVerifyForm.validate();
      if (this.submitBusy || !isValid) return;
      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: "#loginSubmitButton",
        scale: 0.45,
      });

      try { 
          this.formSmsVerify.UserId = this.smsUserId;
          let response = await AuthApi.forgotSmsVerify(
            this.formSmsVerify,
            this
          );

          setTimeout(() => {
            this.$vs.loading.close(".con-vs-loading");
          }, 100);

          if (!response.data.error) {
            this.showSmsConfirmPanel = false;
            this.smsExpiryDate = null;
            this.smsUserId = null;
            this.smsPhone = null;
            this.smsMail = null;
            this.showNewPasswordPanel = true;
            this.UserId = response.data.Token;
          } 
      } finally {
        this.submitBusy = false;
      }
    },
    async newPassword() {
      const isValid = await this.$refs.newPasswordForm.validate();
      if (this.submitBusy || !isValid) return;

      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: "#loginSubmitButton",
        scale: 0.45,
      });

      try { 
          this.formNewData.Token = this.$auth.getToken(); 
          let response = await AuthApi.newPasswordOld(this.formNewData, this);

          setTimeout(() => {
            this.$vs.loading.close(".con-vs-loading");
          }, 100);

          if (!response.data.error) {
            this.showNewPasswordPanel = false;
            this.formForgotData = {
              Email: "",
              IdentityNumber: "",
              GoogleReCaptchaResponse: "",
            };

            this.formNewData = {
              Token: null,
              Password: "",
              PasswordRe: "",
              GoogleReCaptchaResponse: "",
            };

            this.$vs.dialog({
              time: 2500,
              acceptText: this.$t("Accept"),
              title: this.$t("Success"),
              text: this.$t("Login.SuccessResetPassword"),
              color: "success",
            });

            this.$router.push("/"); 
          } 
      } catch {
        setTimeout(() => {
          this.$vs.loading.close(".con-vs-loading");
        }, 100);
      } finally {
        this.submitBusy = false;  
      }
    },
    async forgotPassword() {
      const isValid = await this.$refs.forgotPasswordForm.validate();
      if (this.submitBusy || !isValid) return;

      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: "#loginSubmitButton",
        scale: 0.45,
      });
      try {
        this.$recaptcha("login").then(async (token) => {
          this.formForgotData.GoogleReCaptchaResponse = token;
          let response = await AuthApi.forgotPassword(
            this.formForgotData,
            this
          );

          setTimeout(() => {
            this.$vs.loading.close(".con-vs-loading");
          }, 100);

          if (!response.data.error) {
            this.smsExpiryDate = response.data.SmsCodeValidTime;
            this.smsCounter = response.data.TotalSecond;
            this.smsUserId = response.data.UserId;
            this.smsPhone = response.data.PhoneNumber;
            this.smsMail = response.data.Email;
            this.showSmsConfirmPanel = true;
            checkSmsCounter = setInterval(() => {
              this.dateNow = new Date();
              if (!this.showSmsTimer) {
                clearInterval(checkSmsCounter);
                this.formSmsVerify = {
                  UserId: null,
                  SmsCode: "",
                  GoogleReCaptchaResponse: "",
                };
                this.formForgotData = {
                  Email: "",
                  IdentityNumber: "",
                  GoogleReCaptchaResponse: "",
                };
                this.showSmsConfirmPanel = false;
                this.smsExpiryDate = null;
                this.smsUserId = null;
                this.smsPhone = null;
                this.smsMail = null;
              }
            }, 1000);
          }
        });
      } catch {
        setTimeout(() => {
          this.$vs.loading.close(".con-vs-loading");
        }, 100);
      } finally {
        this.submitBusy = false;
      }
    },
  },
};
</script>

<style lang="scss">
.full-page-bg-color {
  background: white !important;
}

.vx-card-fsm {
  border-radius: 1.5rem;
}
.light-shadow {
  .vx-card:hover {
    box-shadow: unset !important;
  }
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

#login-loader {
  width: 16px;
  height: 16px;
  float: left;
  margin-right: 5px;
}
</style>

<style lang="scss">
.count-down {
  display: table;
  margin: 0 auto;
  cursor: default;
  pointer-events: none;
  .percent {
    position: relative;
    &-text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #26c68a;
      font-size: 50px;
      line-height: 1;
      font-weight: bold;
      transition: all 0.5s linear;
    }
    svg {
      margin: 0 auto;
      position: relative;
      display: flex;
      circle {
        width: 100%;
        height: 100%;
        fill: none;
        stroke: #fff;
        stroke-width: 10;
        stroke-linecap: round;
        transform: translate(5px, 5px);
        &:last-child {
          stroke: #21cf90;
          transition: all 0.1s linear;
          position: absolute;
          transform: translate(5px, -5px) rotate(-90deg);
          transform-origin: center center;
        }
      }
    }
  }
}
.w-100 {
  width: 100%;
}
.vx-card-fsm {
  max-width: 423px;
  width: 100vh;
}

@media (max-width: 450px) {
  .vx-card-fsm {
    width: 100% !important;
  }
}
</style>
